/* ============================================================
   JS MILLENIUM — Bouton "Explorer" du hero : redirection conditionnelle
   À mettre dans ton fichier assets/jsm-custom.js

   PRINCIPE :
   - Le <body> porte "jsm-locked" quand le client n'est PAS approuvé.
   - Si "jsm-locked" présent → le bouton Explorer pointe vers le formulaire.
   - Sinon (approuvé) → le bouton garde son lien vers le catalogue.

   NB : on cible le bouton par sa CLASSE (présente sur le site live),
   et non par data-shopify-editor-block (qui n'existe QUE dans l'éditeur
   admin — c'est pour ça que ça ne marchait pas sur le live).
   ============================================================ */

(function () {
  // ── RÉGLAGE : mets ici l'URL exacte de ta page formulaire ──
  var URL_FORMULAIRE = '/pages/demande-dacces'; // ← adapte si besoin

  // Classe du bouton Explorer du hero (relevée dans l'inspecteur)
  var SELECTEUR_BOUTON = '.button--AUGlYQndXWnZnSkFGa__button_NM4hUC';

  function redirigerBoutonExplorer() {
    var bouton = document.querySelector(SELECTEUR_BOUTON);
    if (!bouton) return;

    // Client NON approuvé ? (classe jsm-locked sur le body)
    var nonApprouve = document.body.classList.contains('jsm-locked');

    if (nonApprouve) {
      bouton.setAttribute('href', URL_FORMULAIRE);
    }
    // Sinon : on ne touche à rien (le bouton garde son lien catalogue)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', redirigerBoutonExplorer);
  } else {
    redirigerBoutonExplorer();
  }
})();